var map = {
	"./aazady.png": 127,
	"./address_image.svg": 128,
	"./animated_logo.svg": 129,
	"./cloud_infrastructure.svg": 130,
	"./feelingProud.svg": 131,
	"./fullstack.svg": 132,
	"./jsFramework.svg": 133,
	"./profile1.jpg": 56,
	"./projects_image.svg": 134,
	"./ui_ux_design.svg": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;